import { render, staticRenderFns } from "./FilePreviewElement.vue?vue&type=template&id=558ba4e7&scoped=true"
import script from "./FilePreviewElement.vue?vue&type=script&lang=js"
export * from "./FilePreviewElement.vue?vue&type=script&lang=js"
import style0 from "./FilePreviewElement.vue?vue&type=style&index=0&id=558ba4e7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558ba4e7",
  null
  
)

export default component.exports